import { configureStore } from "@reduxjs/toolkit";
import survey from "./pages/surveyBuilder/surveySlice";

export const store = configureStore({
   reducer: { survey }
});
